import React, { Component } from 'react';
import { Button, Theme, WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import {format} from 'date-fns';
import cx from 'classnames';
import { SORTING_ORDER } from '../../constant/content';

const styles = (theme: Theme) => createStyles({
    openContainer: {
        boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#fff",
        position: "fixed",
        right: 0,
        zIndex: 100,
        maxWidth: "360px",
        width: "100%",
        top: 60,
        transition: "all .4s ease-in-out",
        display: 'block',
        overflow: "auto",
        height: "100%",
    },
    ratingReviewSidebar: {
        paddingBottom: '6.25rem',
        '& .header-block': {
            fontSize: '1rem',
            fontWeight: 700,
            lineHeight: '138%',
            color: '#000000',
            padding: '0.75rem 2.5rem 0.75rem 1.25rem',
            borderBottom: '1px solid #DFDFDF',
            position: 'sticky',
            top: '0',
            backgroundColor: '#ffffff',
            zIndex: 1,
            '& .close-icon': {
                position: 'absolute',
                right: '1.25rem',
                top: '1rem',
                cursor: 'pointer',
            }
        },
        '& .total-rating-review-section': {
            backgroundColor: '#FFFAEB',
            padding: '0.63rem 0.25rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.94rem', 
            '& .rating-column': {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.31rem',
                '& .star-icon': {
                    marginTop: '-0.25rem',
                },
                '& .rating-text': {
                    fontSize: '2rem',
                    fontWeight: 600,
                    lineHeight: '150%',
                    color: '#333333',
                },
            },
        },
        '& .rate-review-button-section': {
            backgroundColor: '#ffffff',
            padding: '1.25rem 1.25rem',
            borderBottom: '1px solid #E6E6E6',
            gap: '1rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            '& .review-number': {
                fontSize: '0.88rem',
                fontWeight: 700,
                lineHeight: '142%',
                color: '#666666',
                margin: '0px',
                padding: '0px',
            },
            '& .primary-btn': {
                minWidth: '7.56rem',
                height: '2.25rem',
                borderRadius: '0.25rem',
                fontSize: '0.88rem',
                fontWeight: 400,
                lineHeight: '136%',
                padding: '0.5rem 0.75rem',   
            }
        },
        '& .reviewer-block': {
            borderBottom: '1px solid #E6E6E6',
            padding: '0 1.25rem',
            '&:last-child': {
                borderBottom: 'none',
            },
            '& .reviewer-item': {
                padding: '0.94rem 0 1.44rem',
                borderBottom: '1px solid #E6E6E6',
                display: 'flex',
                gap: '0.31rem',
                '&:last-child': {
                    borderBottom: 'none',
                }
            },
            '& .reviewer-thumbnail': {
                width: '1.5rem',
                minWidth: '1.5rem',
                height: '1.5rem',
                borderRadius: '50%',
                overflow: 'hidden',
                '& img': {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                }
            },
            '& .content-block': {
                width: 'calc(100% - 1.5rem)',
            },
            '& .reviewer-name-row': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '1rem',
                marginBottom: '0.63rem',
                '& .name-text': {
                    fontSize: '0.88rem',
                    fontWeight: 600,
                    margin: '0',
                    lineHeight: '143%',
                    color: '#333333',
                    padding: '0',
                    width: '60%',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                },
                '& .date-text': {
                    fontSize: '0.75rem',
                    fontWeight: 400,
                    lineHeight: '117%',
                    color: '#999999',
                    width: '35%',
                    textAlign: 'right',
                }
            }
        },
        '& .progress-panel': {
            display: 'flex',
            alignItems: 'center',
            gap: '0.38rem',
            margin: '0.16rem 0',
        },
        '& .progress-text': {
            fontSize: '0.75rem',
            fontWeight: 400,
            lineHeight: '150%',
            color: '#999999',
            minWidth: '64px',
            '&.dark-text': {
                fontWeight: 600,
                color: '#666666',
                minWidth: '2.5rem',
            }
        },
        '& .progress-bar': {
            background: '#E6E6E6',
            borderRadius: '0.25rem',
            height: '0.38rem',
            position: 'relative',
            minWidth: '7.313rem',
            width: '100%',
            '& .progress-bar-stripe': {
                position: 'absolute',
                top: '0',
                left: '0',
                height: '100%',
                borderRadius: '0.25rem',
            },
            '&[data-progress-value = "1"] .progress-bar-stripe': {
                width: '10%',
                backgroundColor: '#FF5555',
            },
            '&[data-progress-value = "2"] .progress-bar-stripe': {
                width: '20%',
                backgroundColor: '#FF5555',
            },
            '&[data-progress-value = "3"] .progress-bar-stripe': {
                width: '30%',
                backgroundColor: '#FF5555',
            },
            '&[data-progress-value = "4"] .progress-bar-stripe': {
                width: '40%',
                backgroundColor: '#FF5555',
            },
            '&[data-progress-value = "5"] .progress-bar-stripe': {
                width: '50%',
                backgroundColor: '#FF5555',
            },
            '&[data-progress-value = "6"] .progress-bar-stripe': {
                width: '60%',
                backgroundColor: '#FD8619',
            },
            '&[data-progress-value = "7"] .progress-bar-stripe': {
                width: '70%',
                backgroundColor: '#FAB400',
            },
            '&[data-progress-value = "8"] .progress-bar-stripe': {
                width: '80%',
                backgroundColor: '#3AC7B4',
            },
            '&[data-progress-value = "9"] .progress-bar-stripe': {
                width: '90%',
                backgroundColor: '#5AD271',
            },
            '&[data-progress-value = "10"] .progress-bar-stripe': {
                width: '100%',
                backgroundColor: '#27A940',
            }
        },
        '& .reviewer-message': {
            border: '1px solid #ECECEC',
            backgroundColor: '#F8F8F8',
            boxShadow: '0px 4px 12px 0px #00000005',
            borderRadius: '0.25rem',
            padding: '0.75rem 0.75rem',
            fontSize: '0.75rem',
            fontWeight: 400,
            lineHeight: '133%',
            color: '#333333',
            marginTop: '0.63rem',
        }
    },
    sortByContainer: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        padding: '10px 20px'
    },
    sortBtn: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: '10px',
        cursor: "pointer",
        padding: 5,
        background: "#F8F8F8",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '16px',
        textAlign: "left",
        color: "#666",
    },
    sort: {
        filter: "grayscale(.9) brightness(0.8)",
        cursor: "pointer",
        verticalAlign: -2,
    },
    asc: {
        filter: "none",
        transition: ".2s",
        verticalAlign: -2,
    },
    desc: {
        transition: ".2s",
        transform: "rotate(180deg)",
        filter: "none",
        verticalAlign: -5,
    }
});

interface ViewRatingAndReviewProps extends WithStyles<typeof styles> {
    classes: any;
    contentRatingInfo: any;
    toggleViewRating: Function;
    handleRateQuestionOpen: Function;
}

interface ViewRatingAndReviewStates {
    ratingSortOrder: String;
}

class ViewRatingAndReview extends Component<ViewRatingAndReviewProps, ViewRatingAndReviewStates> {
    constructor(props: ViewRatingAndReviewProps) {
        super(props);
        this.state = {
            ratingSortOrder: ''
        };
    }

    handleSortOrderChange = () => {
        const {ratingSortOrder} = this.state;
        let newOrder = SORTING_ORDER.DESCENDING;
        if(!ratingSortOrder || ratingSortOrder === SORTING_ORDER.DESCENDING) {
            newOrder = SORTING_ORDER.ASCENDING;
        }
        this.setState({ratingSortOrder: newOrder});
    }

    render() {
        const { classes, contentRatingInfo, toggleViewRating } = this.props;
        const {ratingSortOrder} = this.state;
        const overallRating = (contentRatingInfo.contentRatingSummary || {}).overall;
        const overallArticulation = (contentRatingInfo.contentRatingSummary || {}).articulation;
        const overallInnovation = (contentRatingInfo.contentRatingSummary || {}).innovation;
        const {contentRatings = []} = contentRatingInfo;
        contentRatings.sort((a: any, b: any) => {
            const { ratingSortOrder } = this.state;
            const order = (ratingSortOrder === SORTING_ORDER.DESCENDING || !ratingSortOrder) ? 1 : -1;
            const d1 = new Date(a.createdAt), d2 = new Date(b.createdAt);
            if (d1 < d2) return order;
            else if (d1 === d2) return 0;
            return order * -1;
        })
        return (
            <div className={classes.openContainer}>
                <div className={classes.ratingReviewSidebar}>
                    <div className='header-block'>Ratings and Reviews <img className='close-icon' onClick={() => {toggleViewRating()}} src="/assets/svg/contentValidation/close-ic.svg" alt="Close Icon" /></div>
                    <div className='review-body'>
                        <div className='total-rating-review-section'>
                            <div className='rating-column'>
                                <svg className='star-icon' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.2351 0.498099C11.548 -0.166034 12.452 -0.166032 12.7649 0.498101L15.8123 6.96696C15.9365 7.23068 16.1767 7.41348 16.4545 7.45577L23.2688 8.4931C23.9684 8.5996 24.2477 9.50028 23.7415 10.0172L18.8106 15.0525C18.6096 15.2578 18.5179 15.5536 18.5653 15.8434L19.7293 22.9534C19.8489 23.6834 19.1175 24.24 18.4918 23.8954L12.3969 20.5385C12.1484 20.4017 11.8516 20.4017 11.6031 20.5385L5.50822 23.8954C4.88248 24.24 4.15115 23.6834 4.27065 22.9534L5.43467 15.8434C5.48212 15.5536 5.39039 15.2578 5.18937 15.0525L0.258509 10.0172C-0.247724 9.50028 0.0316229 8.5996 0.731219 8.4931L7.5455 7.45577C7.82331 7.41348 8.06346 7.23068 8.1877 6.96695L11.2351 0.498099Z" fill="#FDAD36"/>
                                </svg>
                                <span className='rating-text'>{overallRating}</span>
                            </div>   
                            <div className='progress-column'>
                                <div className='progress-panel'>
                                    <span className='progress-text'>Articulation</span>
                                    <div className='progress-bar' data-progress-value={Math.floor(+overallArticulation)}>
                                        <div className="progress-bar-stripe"></div>
                                    </div>
                                    <span className='progress-text dark-text'>{overallArticulation}/10</span>
                                </div>
                                <div className='progress-panel'>
                                    <span className='progress-text'>Innovation</span>
                                    <div className='progress-bar' data-progress-value={Math.floor(+overallInnovation)}>
                                        <div className="progress-bar-stripe"></div>
                                    </div>
                                    <span className='progress-text dark-text'>{overallInnovation}/10</span>
                                </div>
                            </div>
                        </div>
                        
                        <div className='rate-review-button-section'>
                            <h6 className='review-number'>{contentRatingInfo.totalNoOfRatings} Review{contentRatingInfo.totalNoOfRatings > 1 ? 's' : ''}</h6>
                            <Button
                                className='primary-btn'
                                autoFocus
                                variant="contained"
                                color="primary"
                                disabled={!contentRatingInfo.canSubmitRating}
                                onClick={()=> this.props.handleRateQuestionOpen()}
                            >
                                Rate & Review
                            </Button>
                        </div>
                        <div className={classes.sortByContainer}>
                            <span onClick={this.handleSortOrderChange} className={classes.sortBtn}>
                                Sort By Date
                                <img className={cx(classes.sort, { [classes.asc]: ratingSortOrder === SORTING_ORDER.ASCENDING, [classes.desc]: ratingSortOrder === SORTING_ORDER.DESCENDING })}
                                    src="/assets/img/filter.svg" alt="Filter" />
                            </span>
                        </div>
                        <div className='reviewer-block'>
                            {contentRatings.map((userRating: any) => <div className='reviewer-item'>
                                <span className='reviewer-thumbnail'>
                                    <img src={userRating.user.image || "/assets/svg/contentValidation/reviewer-img.svg"} alt="Thumbnail" />
                                </span>
                                <div className='content-block'>
                                    <div className='reviewer-name-row'>
                                        <h6 className='name-text'>{userRating.user.name}</h6>
                                        <span className='date-text'>{format(new Date(userRating.createdAt), "do MMMM',' yyyy")}</span>
                                    </div>

                                    <div className='progress-panel'>
                                        <span className='progress-text'>Articulation</span>
                                        <div className='progress-bar' data-progress-value={Math.floor(+(userRating.rating.articulation || ''))}>
                                            <div className="progress-bar-stripe"></div>
                                        </div>
                                        <span className='progress-text dark-text'>{userRating.rating.articulation}/10</span>
                                    </div>
                                    <div className='progress-panel'>
                                        <span className='progress-text'>Innovation</span>
                                        <div className='progress-bar' data-progress-value={Math.floor(+(userRating.rating.innovation || ''))}>
                                            <div className="progress-bar-stripe"></div>
                                        </div>
                                        <span className='progress-text dark-text'>{userRating.rating.innovation}/10</span>
                                    </div>
                                    {userRating.rating.review && <div className='reviewer-message'>{userRating.rating.review}</div>}
                                </div>
                            </div>)
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

// @ts-ignore
export default (withStyles(styles)(ViewRatingAndReview));
